import { Map, fromJS } from 'immutable'
import { actions } from './actions'

const initialState = Map({
    gettingIssueWithOrdersArticles: false,
    issuesWithOrdersArticles: null,
    gettingActiveOrdersArticles: false,
    activeOrdersArticles: null,
    gettingPastOrdersIWAOArticles: false,
    gettingPastOrdersIWDPArticles: false,
    pastOrdersIWAOArticles: null,
    pastOrdersIWDPArticles: null,
    creatingVoteArticle: false,
    voteArticles: null,
    gettingVotesByArticle: false,
    votesByArticle: null,
    gettingItemsIssuesList: false,
    itemsIssuesList: null,
    gettingDeliveryIssuesList: false,
    deliveryIssuesList: null,
})

const guides = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case actions.GET_ISSUES_WITH_ORDERS_ARTICLES: {
            return state.merge({
                gettingIssueWithOrdersArticles: true,
                issuesWithOrdersArticles: null,
            })
        }

        case actions.GET_ISSUES_WITH_ORDERS_ARTICLES_SUCCESS: {
            return state.merge({
                gettingIssueWithOrdersArticles: false,
                issuesWithOrdersArticles: fromJS(payload),
            })
        }

        case actions.GET_ISSUES_WITH_ORDERS_ARTICLES_FAILED: {
            return state.merge({
                gettingIssueWithOrdersArticles: false,
                issuesWithOrdersArticles: null,
            })
        }

        case actions.GET_ACTIVE_ORDERS_ARTICLES: {
            return state.merge({
                gettingActiveOrdersArticles: true,
                activeOrdersArticles: null,
            })
        }

        case actions.GET_ACTIVE_ORDERS_ARTICLES_SUCCESS: {
            return state.merge({
                gettingActiveOrdersArticles: false,
                activeOrdersArticles: fromJS(payload),
            })
        }

        case actions.GET_ACTIVE_ORDERS_ARTICLES_FAILED: {
            return state.merge({
                gettingActiveOrdersArticles: false,
                activeOrdersArticles: null,
            })
        }
        case actions.GET_PAST_ORDERS_IWAO_ARTICLES: {
            return state.merge({
                gettingPastOrdersIWAOArticles: true,
                pastOrdersIWAOArticles: null,
            })
        }

        case actions.GET_PAST_ORDERS_IWAO_ARTICLES_SUCCESS: {
            return state.merge({
                gettingPastOrdersIWAOArticles: false,
                pastOrdersIWAOArticles: fromJS(payload),
            })
        }

        case actions.GET_PAST_ORDERS_IWAO_ARTICLES_FAILED: {
            return state.merge({
                gettingPastOrdersIWAOArticles: false,
                pastOrdersIWAOArticles: null,
            })
        }

        case actions.GET_PAST_ORDERS_IWDP_ARTICLES: {
            return state.merge({
                gettingPastOrdersIWDPArticles: true,
                pastOrdersIWDPArticles: null,
            })
        }

        case actions.GET_PAST_ORDERS_IWDP_ARTICLES_SUCCESS: {
            return state.merge({
                gettingPastOrdersIWDPArticles: false,
                pastOrdersIWDPArticles: fromJS(payload),
            })
        }

        case actions.GET_PAST_ORDERS_IWDP_ARTICLES_FAILED: {
            return state.merge({
                gettingPastOrdersIWDPArticles: false,
                pastOrdersIWDPArticles: null,
            })
        }

        case actions.VOTE_THE_ARTICLE: {
            return state.merge({
                creatingVoteArticle: true,
                voteArticles: null,
            })
        }

        case actions.VOTE_THE_ARTICLE_SUCCESS: {
            return state.merge({
                creatingVoteArticle: false,
                voteArticles: fromJS(payload),
            })
        }

        case actions.VOTE_THE_ARTICLE_FAILED: {
            return state.merge({
                creatingVoteArticle: false,
                voteArticles: null,
            })
        }

        case actions.GET_VOTES_BY_ARTICLE: {
            return state.merge({
                gettingVotesByArticle: true,
                votesByArticle: null,
            })
        }

        case actions.GET_VOTES_BY_ARTICLE_SUCCESS: {
            return state.merge({
                gettingVotesByArticle: false,
                votesByArticle: fromJS(payload),
            })
        }

        case actions.GET_VOTES_BY_ARTICLE_FAILED: {
            return state.merge({
                gettingVotesByArticle: false,
                votesByArticle: null,
            })
        }

        case actions.GET_ITEMS_ISSUES_LIST: {
            return state.merge({
                gettingItemsIssuesList: true,
                itemsIssuesList: null,
            })
        }

        case actions.GET_ITEMS_ISSUES_LIST_SUCCESS: {
            return state.merge({
                gettingItemsIssuesList: false,
                itemsIssuesList: fromJS(payload),
            })
        }

        case actions.GET_ITEMS_ISSUES_LIST_FAILED: {
            return state.merge({
                gettingItemsIssuesList: false,
                itemsIssuesList: null,
            })
        }

        case actions.GET_DELIVERY_ISSUES_LIST: {
            return state.merge({
                gettingDeliveryIssuesList: true,
                deliveryIssuesList: null,
            })
        }

        case actions.GET_DELIVERY_ISSUES_LIST_SUCCESS: {
            return state.merge({
                gettingDeliveryIssuesList: false,
                deliveryIssuesList: fromJS(payload),
            })
        }

        case actions.GET_DELIVERY_ISSUES_LIST_FAILED: {
            return state.merge({
                gettingDeliveryIssuesList: false,
                deliveryIssuesList: null,
            })
        }

        default:
            return state
    }
}
export default guides
